export const OPENING_IDS = [
  "italian",
  "quietTwoKnights",
  "queensGambit",
  "ruyLopez",
  "english",
  "london",
  "alapin",
  "vienna",
  "scotch",
  "fourKnights",
  "reti",
  "openSicilian",
  "kingsGambit",
  "pircModern",
  "frenchAdvance",
  "scandinavian",
  "caroAdvance",
  "caroKann",
  "qgdBlack",
  "symmetricalEnglish",
  "openGame",
  "sicilianNajdorf",
  "kingsIndian",
  "frenchDefense",
  "kingsEnglish",
  "petroffDefense",
  "philidorDefense",
  "slavDefense",
  "nimzoIndian",
  "scandinavianDefense",
  "pircDefense",
  "qgaBlack",
  "twoKnights",
  "englishNf6",
  "retiBlack",
  "classicalSicilian",
  "kanSicilian",
  "berlinDefense",
  "steinitzDefense",
  "classicalRuy",
] as const;

export type OpeningId = (typeof OPENING_IDS)[number];

export const CONCEPT_TAGS = [
  "center",
  "development",
  "king-safety",
  "castle",
  "early-queen",
  "piece-twice",
  "flank-pawn",
  "tempo",
  "initiative",
  "target-f7",
  "pawn-structure",
  "flank",
  "flexible",
  "bishop-trapped",
] as const;

export type ConceptTag = (typeof CONCEPT_TAGS)[number];

export const OPENING_ID_SET = new Set<string>(OPENING_IDS);
export const CONCEPT_TAG_SET = new Set<string>(CONCEPT_TAGS);

export function isOpeningId(id: string): id is OpeningId {
  return OPENING_ID_SET.has(id);
}

export function isConceptTag(tag: string): tag is ConceptTag {
  return CONCEPT_TAG_SET.has(tag);
}

export function unknownConceptTags(tags: string[]): string[] {
  return [...new Set(tags)].filter((tag) => !CONCEPT_TAG_SET.has(tag));
}
